<template>
  <div class="card maturityR">
    <div class="card-header bg-transparent">
      <div class="row align-items-center">
          <div class="col green">
            <h3><i class="fas fa-chart-line"></i>Outstanding Bids</h3>
          </div>
          <div class="text-right" v-if="isAdmin || isTrader && isEditor">
            <a @click="navigateListPage()" class="moreinfo cursor-pointer"><i class="fas fa-chevron-circle-right"></i> More Info</a>
          </div>
      </div>
    </div>
    <div class="card-body bid-detail">
      <div class="bid mb-5">Total Bids: <span>{{outstandingBids.bidsCount }}</span></div>
      <div class="capital">Total Quantity: <span>{{outstandingBids.bidsQuantity}}</span></div>
      <a v-if="outstandingBids.bidsCount != 0" href="#"  data-toggle="modal" data-target="#cancelBidModal" class="red-btn"><i class="fas fa-times-circle"></i> Cancel All Bids</a>
      <a v-if="outstandingBids.bidsCount == 0" class="red-btn cancel-bid-btn"><i class="fas fa-times-circle"></i> Cancel All Bids</a>
    </div>
     <div
        class="modal fade"
        id="cancelBidModal"
        tabindex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Confirm</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <i class="fas fa-exclamation-triangle"></i>
              <p>{{appMessages.cancelAllBidsConfirm}}</p>
              <div v-if="loading"  class="loader"><img src="../../../../assets/img/loader.svg" alt=""/></div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">No</button>
              <button type="button" class="btn btn-danger" @click="cancelAllBids()">Yes</button>
            </div>
          </div>
        </div>
      </div>
  </div> 
</template>
<script>
import authService from "@/authService";
//import $ from "jquery";
//import axios from "axios";
import config from "@/config";
export default {
  name: "outstandingbid",
  data() {
    return {
      accessToken : null,
      outstandingBids : {
        bidsCount : 0,
        bidsQuantity : 0
      },
      isTrader : false,
      isEditor : false,
      isSuperAdmin : false,
      isAdmin: false,
      loading : false
    };
  },
  methods: {
    getOutstandingBids(){
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
          config.baseUrlBidSide +
            "/bid/outstanding",
            auth

        )
        .then(result => {
          this.outstandingBids = result.data
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    cancelAllBids(){
      this.loading = true;
      const auth = {
        headers: { authorization: this.accessToken ,'org-token' : authService.getOrgToken() }
      };
      this.$http
        .post(
          config.baseUrlBidSide + "/bid/cancel-all",
          {
            
          },
          auth
        )
        .then(() => {
         this.$alert(this.appMessages.bidCancelSuccess);
         this.loading = false;
         window.$("#cancelBidModal").modal("hide");
         this.getOutstandingBids();
        })
        .catch(e => {
          console.log(e);
          this.loading = false;

        });
    },
    navigateListPage(){
      if(this.isAdmin){
        window.location.href = "/bidside/bidlist";
      }
      if(this.isTrader && this.isEditor){
        window.location.href = "/bidside/bidlist";
      }
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
    
  },
  mounted() {
    this.$cognitoAuth.getIdToken((err, result) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        this.accessToken = result;
        this.getOutstandingBids();
      }
     }); 

    this.$cognitoAuth.getUserGroup((err, role) => {
      if (err) {
        console.log("accessToken is not found", err);
      } else {
        
        this.roleArray = role.map(item => {return  item.split("-")[1]});

        this.roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
        this.roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
        this.roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
        this.roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
      }
    });
  }
};
</script>